import api from "@/api/apiConfig"
import {
  Post,
  Get
} from './base/baseAjax'

let getapprovallist = (param) => {
  return Post({
    url: api.leaveSituation.getapprovallist,
    bodyParam: param
  })
}
let getapprovaldetail = (param) => {
  return Get({
    url: api.leaveSituation.getapprovaldetail,
    PathParam: param
  })
}

export default {
  getapprovallist,
  getapprovaldetail
}



// WEBPACK FOOTER //
// ./src/services/leaveSituation.js